module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M31.768 16.008c-.9-7.238-6.638-12.964-13.876-13.87V1a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1.138C6.652 3.042.914 8.77.014 16.008-.124 17.102.786 18 1.89 18h12v8c0 1.102-.896 2-2 2s-2-.898-2-2c0-1.106-.894-2-2-2s-2 .894-2 2c0 3.308 2.692 6 6 6s6-2.692 6-6v-8h12c1.106 0 2.014-.898 1.878-1.992z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/umbrella-1.js
// module id = 1464
// module chunks = 14